import React, { useState, useEffect } from "react";
import { Box, useMediaQuery, Typography } from "@mui/material";

const Exhibition = ({ data = [] }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loadedImages, setLoadedImages] = useState({});
  const isTab = useMediaQuery("(max-width:770px)");

  // Handle image loading
  const handleImageLoad = (index) => {
    setLoadedImages((prev) => ({ ...prev, [index]: true }));
  };

  // Auto-rotate through exhibitions
  useEffect(() => {
    if (data.length <= 1) return;

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % data.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [data.length]);

  if (data.length === 0) {
    return (
      <Box sx={{ height: "300px", display: "grid", placeItems: "center" }}>
        <Typography variant="h6">No exhibitions available</Typography>
      </Box>
    );
  }

  const currentItem = data[currentIndex];
  const imageUrl = currentItem?.imagePath || currentItem?.image; // Try both common image property names
  const hasImage = loadedImages[currentIndex] && imageUrl;

  return (
    <Box
      sx={{
        display: "flex",
        gap: 4,
        alignItems: "center",
        flexDirection: isTab ? "column" : "row",
        width: "90%",
        margin: "auto",
        marginTop: "2rem",
        minHeight: "400px", // Ensure consistent height
      }}
    >
      {/* Image Section */}
      <Box
        sx={{
          width: isTab ? "100%" : "50%",
          aspectRatio: "1 / 1",
          overflow: "hidden",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "0.5rem",
          backgroundColor: "rgba(0,0,0,0.1)",
          position: "relative",
        }}
      >
        {imageUrl && (
          <Box
            component="img"
            src={imageUrl}
            alt={currentItem?.title || "Exhibition"}
            onLoad={() => handleImageLoad(currentIndex)}
            onError={() => handleImageLoad(currentIndex)} // Fallback if image fails to load
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: hasImage ? "block" : "none",
              position: "absolute",
            }}
          />
        )}
        {!hasImage && (
          <Typography
            variant="body1"
            sx={{
              textAlign: "center",
              padding: 2,
              color: "text.secondary",
            }}
          >
            {imageUrl ? "Loading image..." : "No image available"}
          </Typography>
        )}
      </Box>

      {/* Text Section */}
      <Box
        sx={{
          width: isTab ? "100%" : "50%",
          px: isTab ? 0 : 2,
          color: "white",
          textAlign: "center",
        }}
      >
        <Box sx={{ mb: 2, fontSize: "1.5rem", fontWeight: "600" }}>
          {currentItem?.title || "Untitled Exhibition"}
        </Box>
        <Box sx={{ lineHeight: 1.6 }}>
          {currentItem?.description || "Description not available"}
        </Box>
      </Box>
    </Box>
  );
};

export default Exhibition;
